export function cigarettesShort(value) {
	if (value === 0) return 'Niet gemeten';
	if (value === 1) return 'Geen';
	if (value < 10) return '< 10';
	if (value > 10) return '> 10';
}

export default { cigarettesShort };
